var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "quiz-height-calculator" }, [
    _c("div", { staticClass: "calculator__container" }, [
      this.units.length > 1
        ? _c(
            "div",
            { staticClass: "calculator__units" },
            _vm._l(_vm.units, function(unit, i) {
              return _c(
                "div",
                {
                  key: unit.name,
                  staticClass: "unit",
                  class: { unit_active: i === _vm.activeUnitIndex },
                  on: {
                    click: function($event) {
                      _vm.activeUnitIndex = i
                    }
                  }
                },
                [_vm._v("\n        " + _vm._s(unit.name) + "\n      ")]
              )
            }),
            0
          )
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "calculator__content" }, [
        _c(
          "div",
          { staticClass: "calculator__input" },
          [
            !_vm.activeUnit.parts
              ? _c("div", { staticClass: "input__wrapper" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.value,
                        expression: "value"
                      }
                    ],
                    style: { maxWidth: _vm.inputLength + "ch" },
                    attrs: {
                      type: "number",
                      min: _vm.minCorrected,
                      max: _vm.maxCorrected,
                      maxlength: _vm.max.toString().length,
                      placeholder: _vm.placeholder
                    },
                    domProps: { value: _vm.value },
                    on: {
                      change: _vm.validateInput,
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.value = $event.target.value
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "input__units" }, [
                    _vm._v(_vm._s(_vm.activeUnit.name))
                  ])
                ])
              : [
                  _c("div", { staticClass: "input__wrapper" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.ft,
                          expression: "ft"
                        }
                      ],
                      style: { maxWidth: _vm.inputLength + "ch" },
                      attrs: {
                        type: "number",
                        min: _vm.minCorrected,
                        max: _vm.maxCorrected,
                        maxlength: _vm.max.toString().length,
                        placeholder: _vm.placeholder
                      },
                      domProps: { value: _vm.ft },
                      on: {
                        change: _vm.validateFtInput,
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.ft = $event.target.value
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "input__units" }, [
                      _vm._v(_vm._s(_vm.activeUnit.parts[0].name))
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "input__wrapper" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.inches,
                          expression: "inches"
                        }
                      ],
                      style: { maxWidth: _vm.inputLength + "ch" },
                      attrs: {
                        type: "number",
                        min: 0,
                        max: 11,
                        maxlength: 2,
                        placeholder: _vm.placeholder
                      },
                      domProps: { value: _vm.inches },
                      on: {
                        change: _vm.validateInchInput,
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.inches = $event.target.value
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "input__units" }, [
                      _vm._v(_vm._s(_vm.activeUnit.parts[1].name))
                    ])
                  ])
                ]
          ],
          2
        ),
        _vm._v(" "),
        !_vm.hideCaption
          ? _c("p", {
              staticClass: "input__caption",
              domProps: {
                innerHTML: _vm._s(
                  _vm.$t("quiz.list[1].caption", {
                    mn: _vm.minCorrected,
                    mx: _vm.maxCorrected,
                    nm: _vm.activeUnit.name
                  })
                )
              }
            })
          : _vm._e()
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }